import styled from 'styled-components';
import prop from 'ramda/es/prop';

export const Button = styled.button`
  display: inline-block;
  width: 45px;
  height: 45px;
  cursor: pointer;
  border: none;
  
  font-size: 0;
  line-height: 0;
  
  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    height: 2px;
    width: 14px;
    background-color: ${prop('iconColor')};
    transition: transform .2s ease-in-out, background-color .2s ease-in-out;
  }
  
  &:before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  
  &:after {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  
  &:hover {
    &:before {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    
    &:after {
      transform: translate(-50%, -50%) rotate(135deg);
    }
  }
`;
